/*
  ドラッグ移動（カスタムディレクティブ）
  
  HTML要素をドラッグ＆ドロップで移動させる

  ■オプション設定
    例：v-drag="{notUse: true, targetIdClass: '#idClass', moveX: false, moveY: false, cursor: true}"
    
    notUse: この処理を使用しない（デフォルト：false）※v-ifでの設定切り替えはtemplateが冗長になるため
    targetIdClass：移動させたい要素のid・class（'#','.'込みで設定）※最初の1つの要素のみ適用
    moveX：横に移動させる（デフォルト：true）
    moveY：縦に移動させる（デフォルト：true）
    cursor: 「cursor: move」を適用させる（デフォルト：false）
  
  ■使用方法
    グローバルディレクティブに設定するか、使用したいVueファイルにimportし、ローカルディレクティブに設定する
    例：グローバル app.directive("drag", draggable)
        ローカル   directives: { drag: draggable }
    
    パターン1：移動対象要素を直接ドラッグして移動させたい場合
      ドラッグ移動させたい要素に「v-drag」をセット

    パターン2：移動対象要素の一部のタグをドラッグして移動させたい場合
      ドラッグする要素に「v-drag」をセットし、オプション「id」または「class」に移動対象要素を設定する
*/

export const draggable = {
  mounted(el: any, binding: any) {
    const data = {
      notUse: binding.value?.notUse === true ? binding.value.notUse : false,
      targetIdClass: binding.value?.targetIdClass ? binding.value.targetIdClass : "",
      moveX: binding.value?.moveX === false ? binding.value.moveX : true,
      moveY: binding.value?.moveY === false ? binding.value.moveY : true,
      cursor: binding.value?.cursor === true ? binding.value.cursor : false,
      fixed: false
    }
    if (data.notUse) { return; };

    if (data.cursor) { el.style.cursor = "move"; }

    // ドラッグ移動対象要素取得
    let target = el;
    if (data.targetIdClass) {
      target = document.querySelector(data.targetIdClass);
    }
    if (target) {
      const css = getComputedStyle(target, null);
      const position = css.getPropertyValue("position");
      if (position === "fixed") {
        data.fixed = true;
      }
    } else {
      return;
    }

    // 移動開始
    el.onmousedown = function (event: MouseEvent) {
      event.preventDefault();
      
      let shiftX = event.clientX - target.getBoundingClientRect().left;
      let shiftY = event.clientY - target.getBoundingClientRect().top;
      if (data.fixed) {
        shiftX = event.pageX - target.getBoundingClientRect().left;
        shiftY = event.pageY - target.getBoundingClientRect().top;
      }

      document.body.addEventListener('mousemove', onMouseMove);

      // 移動
      function onMouseMove(event: MouseEvent) {
        if (data.fixed) {
          if (data.moveX) {
            target.style.left = event.clientX - shiftX + window.scrollX + 'px';
          }
          if (data.moveY) {
            target.style.top = event.clientY - shiftY + window.scrollY + 'px';
          }
        } else {
          if (data.moveX) {
            target.style.left = event.pageX - shiftX + 'px';
          }
          if (data.moveY) {
            target.style.top = event.pageY - shiftY + 'px';
          }
        }
      }

      // 移動終了
      document.onmouseup = function () {
        document.body.removeEventListener('mousemove', onMouseMove);
        document.onmouseup = null;
      };
    };

    // ブラウザ独自のドラッグ処理が実行されないようにする
    el.ondragstart = function() {
      return false;
    };
  }
};